import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Permission } from "../../interface/types";
import { PermissionsPayload, Profile } from "../../interface/interfaces";

interface MerchantState {
  profile: Profile | Record<string, never>;
  permissions: Permission[];
}

const getFromLocalStorage = <T,>(key: string, defaultValue: T): T => {
  try {
    const storedValue = localStorage.getItem(key);
    return storedValue && storedValue !== "undefined"
      ? JSON.parse(storedValue)
      : defaultValue;
  } catch (error) {
    return defaultValue;
  }
};

// Initial state
const initialState: MerchantState = {
  profile: getFromLocalStorage<Profile>("profile", {} as Profile),
  permissions: getFromLocalStorage<Permission[]>("permissions", []),
};

const merchantSlice = createSlice({
  name: "merchants",
  initialState,
  reducers: {
    savePermissions: (state, action: PayloadAction<PermissionsPayload>) => {
      state.permissions = action.payload.permissions;
      localStorage.setItem(
        "permissions",
        JSON.stringify(action.payload.permissions)
      );
    },
    saveProfile: (state, action: PayloadAction<Profile>) => {
      state.profile = action.payload;
      localStorage.setItem("profile", JSON.stringify(action.payload));
    },
  },
});

export const { savePermissions, saveProfile } = merchantSlice.actions;
export default merchantSlice.reducer;
